import React, {Component} from "react";
import User from "../backend/User";
import UserData from "../backend/dataservices/UserData";
import {Grid} from "@mui/material";
import CustomCardComponent from "../components/CustomCardComponent";
import {Link} from "react-router-dom";
import NavbarComponent from "../components/NavbarComponent";
import CustomCardLinkComponent from "../components/CustomCardLinkComponent";
import Config from "../utils/Config";
import StatsData from "../backend/dataservices/StatsData";

class StartPage extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            welcomePhrase: "",
            employeesCount: 0,
            trainingsCount: 0
        };
    }

    componentDidMount() {
        UserData.getFirstName(User.getUserID()).then((name) => {
            this.setState({welcomePhrase: this.constructWelcomePhrase(name)});
        });

        StatsData.fetchDisciplinarianStatistics().then(stats => {
            this.setState({trainingsCount: stats.attendanceCount, employeesCount: stats.employeeCount})
        })

    }

    constructWelcomePhrase = (name) => {
        let phrase = '';
        let hour = new Date().getHours()

        if (hour < 12) {
            phrase = `Guten Morgen ${name}!`;
        } else if (hour >= 12 && hour < 18) {
            phrase = `Guten Mittag ${name}!`;
        } else {
            phrase = `Guten Abend ${name}!`;
        }
        return phrase
    }

    buildEmployeesLink = {
        text: "Du verwaltest derzeit ",
        link: " MitarbeiterInnen"
    };

    buildTrainingsLink = {
        text1: "Derzeit sind ",
        link: " Schulungen ",
        text2: "für deine MitarbeiterInnen dieses Jahr geplant"
    };



    render() {
        return (
            <div>
                <NavbarComponent initValue={"/start"}/>
                <div style={{margin: '20px'}}>
                    <h1>{this.state.welcomePhrase}</h1>
                </div>
                <div style={{padding: '20px 100px 5% 100px', borderBottom: '1px solid lightgrey'}}>
                    <Grid container spacing={20}>
                        <Grid item xs={6}>
                            <CustomCardComponent background={'rgb(1,180,162)'} title={"Team"} text={<>{this.buildEmployeesLink.text}{<Link to={"/overview"}>{this.state.employeesCount}{this.buildEmployeesLink.link}</Link>}</>}/>
                        </Grid>
                        <Grid item xs={6}>
                            <CustomCardComponent background={'rgb(1,180,162)'} title={"Schulungen"} text={<>{this.buildTrainingsLink.text1}{<Link to={"/matrix"}>{this.state.trainingsCount}{this.buildTrainingsLink.link}</Link>}{this.buildTrainingsLink.text2}</>}/>
                        </Grid>
                    </Grid>
                </div>
                <div style={{padding: '20px 100px 0 100px'}}>
                    <Grid container spacing={10}>
                        <Grid item xs={4}>
                            <CustomCardLinkComponent title={"Links"} background={'rgb(83,104,120)'} map={new Map([
                                ['https://intranet.product-training.siemens.com/bt-academy/', 'Academy'],
                                ['https://mylearningworld.siemens.com/web/en/page/home', 'My Learning World'],
                            ])}/>
                        </Grid>
                        <Grid item xs={4}>
                            <CustomCardLinkComponent title={"Letzte Änderungen"} background={'rgb(83,104,120)'} map={new Map([
                                ['', 'Großes WebTrain Update'],
                                ['https://code.siemens.com/lorenz.koenig/webtrain/issues/3', 'Begrüßung mit Vornamen auf Startseite'],
                                ['https://code.siemens.com/lorenz.koenig/webtrain/issues/6', 'Infobereich/News auf der Startseite'],
                            ])}/>
                        </Grid>

                        <Grid item xs={4}>
                            <CustomCardComponent title={"Technischer Support"} background={'rgb(83,104,120)'}
                                                 text={<>Solltest du Probleme bei der Bedienung oder einen möglichen
                                                     Fehler im Tool festgestellt haben, kannst du uns dies gerne
                                                     per Mail an <a href={"mailto:webtrain.gbs@siemens.com"}
                                                                    style={{color: 'white'}}>webtrain.gbs@siemens.com</a> mitteilen.</>}/>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default StartPage;
